export default __webpack_public_path__ + "static/media/matic-logo.ecb243c5.png";